import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { bookingInfo } from '../../booking/book.helper';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
})
export class Step3Component implements OnInit, OnDestroy {
  @Input('updateParentModel') updateParentModel!: (
    part: Partial<bookingInfo>,
    isFormValid: boolean
  ) => void;
  form!: FormGroup;
  @Input() defaultValues!: Partial<bookingInfo>;

  private unsubscribe: Subscription[] = [];

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
    this.updateParentModel({


    }, this.checkForm());
  }

  initForm() {
    this.form = this.fb.group({
      customerName: [null, [Validators.required]],
      customerPhone: [null, [Validators.pattern('^[0-9]{8}$'), Validators.required]],
      customerEmail: [null, [Validators.required, Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$")]],
    });

    const formChangesSubscr = this.form.valueChanges.subscribe((val) => {
      this.updateParentModel(val, this.checkForm());
    });
    this.unsubscribe.push(formChangesSubscr);
  }

  checkForm() {
    return !(
      this.form.get('customerName')?.hasError('required') ||
      this.form.get('customerPhone')?.hasError('required') ||
      this.form.get('customerEmail')?.hasError('required')
    );
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
